import QuestionGame from '../../services/QuestionGame'
import {LOADING, LOADED} from './loading'
import {SET_RANGE} from './ageRange'
import {UPDATED} from './wallet'


export function vote(gameType, yes, callback) {

  return (dispatch, getState) => {

    dispatch({ type: LOADING })

    const state = getState()

    setTimeout(function() {
      QuestionGame.vote(gameType, state.valentine.id, yes, state.ageRange.current[0], state.ageRange.current[1], response => {

        response.mutualDesire
        && typeof window.showMutualDesire === 'function'
        && window.showMutualDesire(state.valentine.id)

        dispatch({
          type: LOADED,
          valentine: response.valentine
        })

        dispatch({
          type: UPDATED,
          votesLeft: response.freePoints.votesLeft,
          disabled: response.freePoints.disabled,
          credits: response.credits,
          freePoints: response.freePoints.count
        })

        typeof callback === 'function' && callback()
      })
    }, 200)
  }
}

export function show(state) {
  return dispatch => {


    var image = new Image()
    image.onload = function() {
      dispatch({
        type: LOADED,
        valentine: state.valentine
      })
      dispatch({
        type: SET_RANGE,
        ageRange: state.ageRange
      })
    }

    image.src = state.valentine.photo
  }
}
